import { TaskStatusCardController } from './task-status-card.controller'

const component = {
  templateUrl: '/workflow/components/task-status-card/task-status-card.html?$$REVISION$$',
  bindings: {
    task: '<',
    variations: '@' // space-delimited
  },
  controllerAs: '$ctrl',
  controller: TaskStatusCardController
}

export const taskStatusCard = component
